<template>
  <router-link class="product-info-container"
               :to="productPath"
  >
      <span class="cover-container">
        <ym-img class="cover"
                :src="cover"
                :alt="title"
        />
      </span>
    <div class="product-info">
      <h2 class="title ym-line-ellipsis">{{ title }}</h2>
      <div>
        <ym-tag class="label-team-size"
                size="small"
                type="highlight-light"
                round
        >
          {{ teamSize }}人成团
        </ym-tag>
        <div class="active-price">
          <price :price="price"
          />
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
  import { Tag } from '@ymba/ym-ui';
  import { getProductPath } from '@/utils';
  import Price from '@/components/Price/ProductDetailPrimaryPrice';

  export default {
    name: 'GroupBuyDetailProduct',
    components: {
      Price,
      YmTag: Tag,
    },
    props: {
      cover: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      price: {
        type: Object,
        required: true,
      },
      teamSize: {
        type: Number,
        required: true,
      },
      productId: {
        type: Number,
        required: true,
      },
      productType: {
        type: String,
        required: true,
      },
    },
    computed: {
      productPrice() {
        return this.benefit ? this.benefit.price : this.price;
      },
      productPath() {
        return getProductPath(this.productType, this.productId);
      },
    },
    methods: {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-info-container {
    background-color: @color-white;
    display: flex;
    justify-content: space-between;
    padding: @size-base @size-medium;
  }

  .cover-container {
    width: 200px;
    height: 160px;
    margin-right: @size-base;
    flex-shrink: 0;
  }

  .cover {
    width: 100%;
    height: 100%;
  }

  .product-info {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title {
    margin: 0 0 @size-small;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
  }

  .active-price {
    margin-top: @size-extra-small;
    display: flex;
    align-items: flex-end;
  }

  .price-name {
    color: @price-color-highlight;
    font-size: @font-size-medium;
    margin-right: @size-extra-small;
  }
</style>
